import { isBlankHtml } from "../helper";
export default function validate(values, langCode) {
    const errors = {};
    const translation = values.translations.find((lang) => lang.langCode === langCode);

    if (!translation || !Array.isArray(translation.author) || translation.author.length === 0) {
      errors.author = "Please provide the author name";
    } else if (translation.author.some(ref => !ref.authorName?.trim())) {
      errors.author = "Each author must have a name";
    }

    if (!translation || !translation.title || translation.title.trim() === "") {
      errors.title = "Please provide the book name";
    }

    if (values.numberOfPages === null || values.numberOfPages === undefined || values.numberOfPages === "") {
      errors.numberOfPages = "Please enter the number of pages";
    }

    if (!values.publishedDate || values.publishedDate === null) {
      errors.publishedDate = "Please enter the published date";
    }

    if (!translation || !translation.publishedBy || translation.publishedBy.trim() === "") {
      errors.publishedBy = "Please provide the name of the publisher";
    }

    // `isBlankHtml`, not a trim: this field is rich text now, and an emptied
    // Quill editor yields `<p><br></p>` rather than "".
    if (!translation || isBlankHtml(translation.summary)) {
      errors.summary = "Please write some words about the book";
    }

    // if (!values.coverImage || Object.keys(values.coverImage).length === 0 || !values.coverImage.uploadedImageUrl) {
    //   errors.coverImage = "Please upload an image";
    // }

    if (!translation || !Array.isArray(translation.genre) || translation.genre.length === 0) {
      errors.genre = "Please add the genres";
    } else if (translation.genre.some(ref => !ref.genreName?.trim())) {
      errors.genre = "Each genre must have a category name";
    }

    if (Object.keys(errors).length > 0) {
      errors.message = "Form validation failed";
    }

    return errors;
};